import { Instance } from "mobx-state-tree"
import { InputPlayerStatsModelBase } from "./InputPlayerStatsModel.base"

/* The TypeScript type of an instance of InputPlayerStatsModel */
export interface InputPlayerStatsModelType extends Instance<typeof InputPlayerStatsModel.Type> {}

/* A graphql query fragment builders for InputPlayerStatsModel */
export { selectFromInputPlayerStats, inputPlayerStatsModelPrimitives, InputPlayerStatsModelSelector } from "./InputPlayerStatsModel.base"

/**
 * InputPlayerStatsModel
 */
export const InputPlayerStatsModel = InputPlayerStatsModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
